import { render, staticRenderFns } from "./TransferCenterAccounting.vue?vue&type=template&id=dcd9a552&scoped=true"
import script from "./TransferCenterAccounting.vue?vue&type=script&lang=js"
export * from "./TransferCenterAccounting.vue?vue&type=script&lang=js"
import style0 from "./TransferCenterAccounting.vue?vue&type=style&index=0&id=dcd9a552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd9a552",
  null
  
)

export default component.exports